import { IMicroservicesSdk } from '@sxm-de/dev-kits/microservices-sdk/core';
import { ErrorLoggerSdk } from '@sxm-de/dev-kits/web-sdk/types';

export class ErrorLoggerSdkMicroservices implements ErrorLoggerSdk {
    constructor(private readonly microservicesSdk: IMicroservicesSdk) {}

    async logError(payload: {
        message: string;
        stacktrace?: string;
    }): Promise<void> {
        try {
            return await this.microservicesSdk.domains.utility.logMessage({
                ...payload,
                logLevel: 'ERROR',
                url: location.href,
                referrer: document.referrer,
            });
        } catch (error: any) {
            /**
             * Note:
             * Silently fail.
             */
        }
    }

    async logInfo(payload: {
        message: string;
        stacktrace?: string;
    }): Promise<void> {
        try {
            return await this.microservicesSdk.domains.utility.logMessage({
                ...payload,
                logLevel: 'INFO',
                url: location.href,
                referrer: document.referrer,
            });
        } catch (error: any) {
            /**
             * Note:
             * Silently fail.
             */
        }
    }
}
